import { Tab, Tabs } from '@mui/material'

type WorkflowTabsProps = {
	currentTab: string
	hideAttachmentsTab?: boolean
	onTabChanged: (event: React.SyntheticEvent, newValue: string) => void
}

export const WorkflowTabs = ({
	currentTab,
	onTabChanged,
}: WorkflowTabsProps) => {
	return (
		<Tabs
			variant="scrollable"
			scrollButtons="auto"
			textColor="primary"
			indicatorColor="primary"
			value={currentTab}
			onChange={onTabChanged}
		>
			<Tab key="Settings" label="Settings" value="settings" />
			<Tab key="Versions" label="Versions" value="versions" />
			<Tab key="History" label="History" value="history" />
			<Tab
				key="Failure Actions"
				label="Failure Actions"
				value="failure-actions"
			/>
		</Tabs>
	)
}
